module.exports = __webpack_public_path__ + "static/media/risk_value_5.88b33f36.png";